<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header titleIcon="server"
    title="LLM Models"
    subtitle="Curated models operators can assign to AI tasks. Model names must match the provider exactly. Only one model may be active at a time."
  />

  <app-entity-catalog
    [catalog]="catalogView"
    [records]="records"
    [loading]="loading"
    [saving]="saving"
    [error]="error"
    [hideTitle]="true"
    [canCreate]="view === 'active'"
    [canEdit]="view === 'active'"
    [canDelete]="view === 'active'"
    [canRestore]="view === 'deleted'"
    [toolbarTabs]="toolbarTabs"
    [activeToolbarTab]="activeToolbarTab"
    (toolbarTabChange)="onToolbarTabChange($event)"
    (save)="onSave($event)"
    (delete)="onDelete($event)"
    (restore)="onRestore($event)"
  />
</div>

<app-delete-confirm-modal
  [open]="showDeleteModal"
  heading="Delete LLM model?"
  [entityName]="deleteEntityName"
  entityNoun="LLM model"
  message="This will remove the model from the list. Task configs that already reference it are unchanged, but the model can no longer be selected."
  confirmLabel="Delete"
  loadingLabel="Deleting…"
  [loading]="deleteLoading()"
  [error]="deleteError"
  variant="permanent"
  (cancelled)="closeDeleteModal()"
  (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal
  [open]="showRestoreModal"
  heading="Restore LLM model?"
  [entityName]="restoreEntityName"
  activeListLabel="LLM models list"
  [loading]="restoreLoading()"
  (cancelled)="closeRestoreModal()"
  (confirmed)="submitRestore()"
/>
